import { Translations } from 'types/Common';
import { IFile, INewsBaseCategory } from 'types/income';
import { z } from 'zod';
import { newsCategoriesFiltersSchema, newsFiltersSchema } from './news.schemas';

export const newsStatuses = [
  'inactive',
  'published',
  'expiresSoon',
  'expired',
  'comingSoon',
  'draft',
] as const;

export type NewsStatus = (typeof newsStatuses)[number];

export const newsSendMethods = ['email', 'appNotification', 'none'] as const;

export type NewsSendMethod = (typeof newsSendMethods)[number];

export type NewTranslations = Translations<{
  title: string;
  content: string;
  headerImage?: IFile;
  attachments: IFile[];
}>;

export interface NewItem {
  id: string;
  name: string;
  status: NewsStatus;
  parentCompanyId: string;
  publishedAt: string | null;
  inactiveAt: string | null;
  sentCount: number;
  seenCount: number;
  sendMethods: NewsSendMethod[];
  translations: NewTranslations;
  pinned: boolean;
  categories: INewsBaseCategory[];
}

export type NewsFilters = z.infer<typeof newsFiltersSchema>;

export type NewsCategoryTranslations = Translations<{ name: string }>;

export interface NewsCategory {
  id: string;
  name: string;
  translations: NewsCategoryTranslations;
  createdAt: string;
  updatedAt: string | null;
}

export type NewsCategoriesFilters = z.infer<typeof newsCategoriesFiltersSchema>;
